import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import SelectField from '~fields/SelectField';
import TextareaField from '~fields/TextareaField';
import PhoneField from '~fields/PhoneField';
import * as api from '~services/api';

const CallSystemForm = props => {
  const { formik, organizations } = props;
  const {
    setFieldValue,
    values: { accountUnit },
  } = formik;
  const [devices, setDevices] = useState([]);

  const fetchDevices = async orgId => {
    try {
      if (!orgId) throw new Error('Organization code not defined');
      const devices = await api.get(
        `data/maintenance/sonds/search?organizationId=${orgId}`
      );
      setDevices(devices);
      setFieldValue(
        'accountNumber',
        devices?.length
          ? {
              value: devices[0].systemId,
              label: devices[0].systemId,
            }
          : null
      );
    } catch (e) {
      setDevices([]);
      console.warn(`fetchDevices: Devices not found for orgId: ${orgId}. ${e}`);
    }
  };

  useEffect(() => {
    const userOrgId = accountUnit?.value;
    if (userOrgId) {
      fetchDevices(userOrgId);
    }
  }, []);

  const accountUnitOptions = organizations.map(o => ({
    value: o.id,
    label: o.name,
  }));

  const accountNumberOptions = devices.map(device => ({
    value: device.systemId,
    label: device.systemId,
  }));

  return (
    <>
      <FieldWrapper>
        <SelectField
          fallbackLabel="Yksikkö"
          name="accountUnit"
          options={accountUnitOptions}
          onChange={org => fetchDevices(org.value)}
          fallbackPlaceholder="Valitse"
          required
          styles={{
            container: provided => ({
              ...provided,
              minWidth: '0px',
            }),
          }}
        />
      </FieldWrapper>

      <FieldWrapper>
        <SelectField
          name="accountNumber"
          options={accountNumberOptions}
          fallbackPlaceholder="Valitse"
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <TextareaField
          name="additionalInfo"
          fallbackLabel="Palvelupyyntö"
          rows={5}
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <PhoneField
          required
          fallbackLabel="Puhelinnumero"
          name="contactPhone"
        />
      </FieldWrapper>
    </>
  );
};

const FieldWrapper = props => <FieldContainer>{props.children}</FieldContainer>;

const FieldContainer = styled.div`
  margin-bottom: 24px;
`;

export default CallSystemForm;
